export default __webpack_public_path__ + "static/media/video_icon_bold.1900f183.svg";